import { render } from "./copyright.vue?vue&type=template&id=fde1c336&scoped=true"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"

import "./copyright.vue?vue&type=style&index=0&id=fde1c336&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde1c336"]])

export default __exports__